import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Download from './icon-download.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Download {...validProps} />;
}
SvgComponent.iconName = 'download';

/**
 * @deprecated This is a legacy icon
 */
export const DownloadIcon = svgIconWrapper(SvgComponent);
